<template>
  <div class="notification animated fadeIn" v-if="notifications.size !== 0">
    <div
      class="notification_block"
      v-for="(notification, index) in notifications"
      :key="index"
      :class="notification.type">
      <div class="notification_content">
        <font-awesome-icon :icon="notification.icon" />
        <p>{{ notification.message }}</p>
        <button class="btn btn-rounded no-bg close" @click="close(index)">
          <font-awesome-icon icon="times" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// Component dependencies
import NotificationService from "@/utils/plugins/NotificationService";

export default {
  name: "notification",
  data() {
    return {
      notificationService: NotificationService,
      notifications: []
    };
  },
  mounted() {
    var content = this.$el;
    var body = document.querySelector('body');
    body.appendChild(content);
  },
  watch: {
    "notificationService.notifications": function(value) {
      this.notifications = value.slice(-5);
    }
  },
  methods: {
    close(index) {
      this.notificationService.removeNotification(index)
    }
  }
};
</script>